import CallUp from "tool-callapp";

/**
 * 分享图片
 * @param obj
 * platform 分享渠道
 * picUrl 图片地址 facebook/whatsApp/wechat_feed/wechat
 */
export const shareImg = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    obj = JSON.stringify(obj);
    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.sharePicTo(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.sharePicTo &&
            window.webkit.messageHandlers.sharePicTo.postMessage(obj);
    }
};

export const system = () => {
    const u = navigator.userAgent;

    let name;
    if (
        u.indexOf("Android") > -1 ||
        u.indexOf("Adr") > -1 ||
        u.indexOf("hshhk/android") > -1
    ) {
        name = "android";
    } else if (
        u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
        u.indexOf("hshhk/ios/") > -1
    ) {
        name = "ios";
    } else {
        name = "unknown";
    }

    return name;
};
/**
 * h5调用客户端开始/结束页面统计
 * @param obj pageId 页面id / start 1.开始；0.结束
 */
export const pageViewStatistics = (obj) => {
    // console.log(obj.pageId, obj.start === 1 ? '开始' : '结束', 'h5调用客户端开始/结束页面统计')
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.pageViewStatistics(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.pageViewStatistics &&
            window.webkit.messageHandlers.pageViewStatistics.postMessage(obj);
    }
};
/**
 * h5切换客户端主题
 * @param
 */

export const changeThemeColor = (index) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    let colorList = [
        "",
        "6A43D1",
        "77290C",
        "09C6A2",
        "ED0080",
        "2F5FE0",
        "60D4FF",
        "00A7FF"
    ];
    let obj = { type: index, color: colorList[index] };
    obj = JSON.stringify(obj);
    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.changeThemeColor(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.changeThemeColor &&
            window.webkit.messageHandlers.changeThemeColor.postMessage(obj);
    }
};
/**
 * h5获取当前客户端主题
 * @param
 */
export const getCurrentThemeColor = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    obj = JSON.stringify(obj);
    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.getCurrentThemeColor(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getCurrentThemeColor &&
            window.webkit.messageHandlers.getCurrentThemeColor.postMessage(obj);
    }
};

export const logEventStatistics = (obj) => {
    // console.log('logEventStatistics:', obj.umkey)
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.logEventStatistics(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.logEventStatistics &&
            window.webkit.messageHandlers.logEventStatistics.postMessage(obj);
    }
};
export const getUserInfo = (obj) => {
    const name = system();
    const isAndroid = name === "android"; //android终端
    const isiOS = name === "ios"; //ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.getBossInfoWithCallback(obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getBossInfoWithCallback &&
            window.webkit.messageHandlers.getBossInfoWithCallback.postMessage(
                obj
            );
    }
};

export const gappparamsselect = (obj) => {
    obj = JSON.stringify(obj);
    window.aspireweb && window.aspireweb.appparamsselect(obj);
};

export const ssologin = (obj) => {
    obj = JSON.stringify(obj);
    window.aspireweb && window.aspireweb.ssologin(obj);
};
/**
 * token失效重新唤起登录，让客户端重新生成新token，getUserInfo可能会返回老token
 */
export const getUserNewInfo = () => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.tokenInvalidAction();
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.tokenInvalidAction &&
            window.webkit.messageHandlers.tokenInvalidAction.postMessage("aa");
    }
};
// h5请求客户端广告权限json
export const getAdPower = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.getAdAuthJsonWithCallback(obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getAdAuthJsonWithCallback &&
            window.webkit.messageHandlers.getAdAuthJsonWithCallback.postMessage(
                obj
            );
    }
};
/**
 * h5控制客户端导航栏字体颜色
 * @param {*} color
 */
export const switchNavColor = (color) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    color = JSON.stringify(color);
    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.setNavibarTintColor(color);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.setNavibarTintColor &&
            window.webkit.messageHandlers.setNavibarTintColor.postMessage(
                color
            );
    }
};
// H5控制客户端webview导航栏按钮
export const controlTopButton = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.setNavigationButtons(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.setNavigationButtons &&
            window.webkit.messageHandlers.setNavigationButtons.postMessage(obj);
    }
};
// 获取app相关信息
export const getDeviceInfo = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    const fn = window[obj.callbackName];
    obj = JSON.stringify(obj);
    if (isAndroid) {
        if (window.HkAndroid && window.HkAndroid.getDeviceInfoWithCallback) {
            window.HkAndroid.getDeviceInfoWithCallback(obj);
        } else {
            fn({
                os: "Android",
                device: null,
                appVersion: null,
            });
        }
    }
    if (isiOS) {
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getDeviceInfoWithCallback
        ) {
            window.webkit.messageHandlers.getDeviceInfoWithCallback.postMessage(
                obj
            );
        } else {
            fn({
                os: "iOS",
                device: null,
                appVersion: null,
            });
        }
    }
};
export const getQueryVariable = (key, href) => {
    href = decodeURIComponent(href || window.location.href);
    let match = href.match(new RegExp("[?&]" + key + "=([^&]*)"));
    return (match && match[1] && decodeURIComponent(match[1])) || "";
};
export const getQueryVariable2 = (key, href) => {
    href = decodeURIComponent(href || window.location.href);
    let match = href.match(new RegExp("[?&]" + key + "=([^]*)"));
    return (match && match[1] && decodeURIComponent(match[1])) || "";
};
export const isApp = () => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    if (isAndroid) {
        return !!window.HkAndroid;
    }

    if (isiOS) {
        return (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getBossInfoWithCallback
        );
    }
};

/**
 * 控制顶部导航栏的显示隐藏及透明度
 */
export const toggleTopbar = (alpha) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    let obj = JSON.stringify({ alpha });

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.setNavibarAlpha(obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.setNavibarAlpha &&
            window.webkit.messageHandlers.setNavibarAlpha.postMessage(obj);
    }
};

export const shareFun = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    let lang = getQueryVariable("lang") || window.localStorage.getItem("lang");
    let fun;

    // 分享
    if (obj.type === 1) {
        if (isAndroid) {
            fun = "initShare";
        }

        if (isiOS) {
            fun = "setShareButton";
        }

        if (obj.url) {
            let _a = document.createElement("a");
            let hasQ = false;

            _a.href = obj.url;
            hasQ = /\?/.test(_a.hash);
            obj.url = hasQ
                ? `${obj.url}&lang=${lang}`
                : `${obj.url}?lang=${lang}`;
        }
    }

    // 紧急电话
    if (obj.type === 2) {
        fun = "setEmergencyButton";
    }
    obj = JSON.stringify(obj);

    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid[fun](obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers[fun] &&
            window.webkit.messageHandlers[fun].postMessage(obj);
    }
};

// 是否在微信中
export const isWx = () => {
    return navigator.userAgent.match(/micromessenger/i) ? true : false;
};

// 字符串模板
export const render = (template, context) => {
    return template.replace(/\{\{(.*?)\}\}/g, (match, key) => context[key]);
};
export const isWeiXin = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === null) {
        return false;
    } else {
        return true;
    }
};
// 唤起App
export const callApp = (url) => {
    const _url = url || location.href;
    const _a = document.createElement("a");
    const callup = new CallUp({
        // 协议头
        PROTOCAL: "launchmylink",

        HOME: "",

        // 唤起失败时的跳转链接
        FAILBACK: {
            ANDROID: "market://details?id=com.ChinaMobile",
            IOS: "https://itunes.apple.com/hk/app/mylink-hk/id483513425?mt=8",
        },

        // Android apk 相关信息
        APK_INFO: {
            PKG: "com.ChinaMobile",
            CATEGORY: "android.intent.category.DEFAULT",
            ACTION: "android.intent.action.VIEW",
        },

        // 唤起超时时间，超时则跳转到下载页面
        LOAD_WAITING: 3000,
    });

    _a.href = _url;

    callup.loadSchema({
        targetURI: _a.hash.indexOf("?") > -1 ? _url : `${_url}?`,
    });
};

export const page500 = (ignoreArr, url) => {
    let ignore = true;
    ignoreArr.forEach(function(v) {
        if (url.match(v)) {
            ignore = false;
            return;
        }
    });
    if (ignore) {
        window.location = `${window.location.origin}${window.location.pathname}#/page500`;
    }
};
//获取客户端版本信息，兼容低版本app
export const getPlatVersion = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    if (isAndroid) {
        // 获取登录后的boss信息
        console.log(
            window.HkAndroid && window.HkAndroid.getVersionInfoWithCallback
        );
        if (window.HkAndroid && window.HkAndroid.getVersionInfoWithCallback) {
            window.HkAndroid.getVersionInfoWithCallback(JSON.stringify(obj));
        } else {
            window[obj.callbackName](undefined);
        }
    }
    if (isiOS) {
        console.log(
            window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.getVersionInfoWithCallback
        );
        // 获取登录后的boss信息
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getVersionInfoWithCallback
        ) {
            window.webkit.messageHandlers.getVersionInfoWithCallback.postMessage(
                JSON.stringify(obj)
            );
        } else {
            window[obj.callbackName](undefined);
        }
    }
};

//客户端保存图片到相册
export const savePhoto = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    obj = JSON.stringify(obj);
    if (isAndroid) {
        // 调用原生的分享功能
        window.HkAndroid && window.HkAndroid.savePhotoToAlbum(obj);
    }

    if (isiOS) {
        // 调用原生的分享功能
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.savePhotoToAlbum &&
            window.webkit.messageHandlers.savePhotoToAlbum.postMessage(obj);
    }
};

export const OpenApp = (url, callback) => {
    const _url = url || "";
    let Value = `launchmylink://${encodeURIComponent(_url)}`;
    let data = { launchmylink: Value };
    // let data = OpenInstall.parseUrlParams() // openinstall.js中提供的工具函数，解析url中的所有查询参数
    const OpenApp = new OpenInstall(
        {
            /* appKey必选参数，openinstall平台为每个应用分配的ID */
            appKey: "umf9a4",
            /* 可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名 */
            // apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
            /* 可选参数，是否优先考虑拉起app，以牺牲下载体验为代价 */
            // preferWakeup:true,
            /* 自定义遮罩的html */
            // mask:function(){
            //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
            // },
            /* openinstall初始化完成的回调函数，可选 */

            onready() {
                let m = this;
                // let button = document.getElementById(id)
                // button.style.visibility = 'visible'
                /* 在app已安装的情况尝试拉起app */
                // m.schemeWakeup()
                if (typeof callback !== "function") {
                    console.log("openapp");
                    /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
                    m.wakeupOrInstall();
                } else {
                    callback(m);
                }
                // button.onclick = function () {
                //   console.log('openappClick')
                //   m.wakeupOrInstall()
                //   return false
                // }
            },
        },
        data
    );
};
//返回客户端
export const cGoBack = () => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端

    if (isAndroid) {
        window.HkAndroid && window.HkAndroid.onNativeBackClick();
    }

    if (isiOS) {
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.onNativeBackClick &&
            window.webkit.messageHandlers.onNativeBackClick.postMessage("aa");
    }
};

/**
 * h5获取当前app版本9.0 9.1
 * @param
 */
export const getVersionInfoWithCallback = (obj) => {
    const name = system();
    const isAndroid = name === "android"; // android终端
    const isiOS = name === "ios"; // ios终端
    obj = JSON.stringify(obj);
    if (isAndroid) {
        // 获取登录后的boss信息
        window.HkAndroid && window.HkAndroid.getVersionInfoWithCallback(obj);
    }

    if (isiOS) {
        // 获取登录后的boss信息
        window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getVersionInfoWithCallback &&
            window.webkit.messageHandlers.getVersionInfoWithCallback.postMessage(
                obj
            );
    }
};

//判断版本号
export const isWhichVersion = (str) => {
    let arr = str.split(".");
    if (Number(arr[0]) > 9) {
        if (Number(arr[1]) >= 0) {
            return true;
        }
    }
    if (Number(arr[0]) === 9) {
        if (Number(arr[1]) >= 1) {
            return true;
        }
    }
    return false;
};

//判断版本号
//判断版本号
export const isWhichVersionNew = () => {
    const u = navigator.userAgent
    let arr = u.split('/')
    let smallArr = Number(arr[2].replace(/\./g, ''))
    if (smallArr >= 910) {
      return true
    }
    return false
  }
//用于区分版本的函数（兼容ios和安卓）2024/2 新增
//组件中调用的示例
// window.xxxMethod=(obj)=>{
//   console.log('aos',Number(obj.replace(/\./g,'')))
// }
// let x=getVersionForAosAndIos({callbackName:'xxxMethod'})
// if(x){
//   console.log('ios',x)
// }
export const getVersionForAosAndIos = (obj) => {
    const name = system()
    const isAndroid = name === 'android' // android终端
    const isiOS = name === 'ios' // ios终端
    if(isAndroid){
      window.HkAndroid&& window.HkAndroid.getVersionInfoWithCallback(JSON.stringify(obj))//obj = {callbackName:'xxx'} xxx为自定义window方法 xxx接受一个obj参数 对obj进行正则替换Number(obj.replace(/\./g,''))
      
    }
    if(isiOS){
      const u = navigator.userAgent
      let arr = u.split('/')
      let version = Number(arr[2].replaceAll('.', ''))
      return version
    }
    //注释
    //version 一个数字 如：1020（对应10.2.0）
}


// WEBPACK FOOTER //
// ./src/util/const.js